import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const Dynamic = ({ diagnosis, emr }) => (
  <Table borderless border="0" cellSpacing="0" cellPadding="0">
    <thead>
      <tr>
        <th colSpan="2">
          <div className="pagination-container">
            <h5>Other Info</h5>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Dx Codes</td>
        <td>
          {diagnosis.bloodGlucose && (
            <>
              <span className="subheader">Blood Glucose:</span>
              <span>{diagnosis.bloodGlucose}</span>
            </>
          )}
          {diagnosis.bloodPressure && (
            <>
              <span className="subheader">Blood Pressure:</span>
              <span>{diagnosis.bloodPressure}</span>
            </>
          )}
          {diagnosis.weight && (
            <>
              <span className="subheader">Weight:</span>
              <span>{diagnosis.weight}</span>
            </>
          )}
          {diagnosis.pulmonary && (
            <>
              <span className="subheader">Pulmonary:</span>
              <span>{diagnosis.pulmonary}</span>
            </>
          )}
          {diagnosis.sleep && (
            <>
              <span className="subheader">Sleep:</span>
              <span>{diagnosis.sleep}</span>
            </>
          )}
          {diagnosis.allCodes && (
            <>
              <span className="subheader">All Codes:</span>
              <span>{diagnosis.allCodes}</span>
            </>
          )}
        </td>
      </tr>
      <tr>
        <td>EMR Details</td>
        <td>
          {emr.account && (
            <>
              <span className="subheader">Patient MRN ID:</span>
              <span>{emr.account}</span>
            </>
          )}
          <span className="subheader">Billing:</span>
          <span>{emr.billing ? 'Yes' : 'No'}</span>
          {emr.billingCycle && (
            <>
              <span className="subheader">Billing Cycle:</span>
              <span>{emr.billingCycle}</span>
            </>
          )}
          {emr.emrId1 && (
            <>
              <span className="subheader">EMR ID 1:</span>
              <span>{emr.emrId1}</span>
            </>
          )}
          {emr.emrId2 && (
            <>
              <span className="subheader">EMR ID 2:</span>
              <span>{emr.emrId2}</span>
            </>
          )}
          {emr.supervisingProviderId && (
            <>
              <span className="subheader">Supervising Provider:</span>
              <span>{emr.supervisingProviderId}</span>
            </>
          )}
          {emr.renderingProviderId && (
            <>
              <span className="subheader">Rendering Provider:</span>
              <span>{emr.renderingProviderId}</span>
            </>
          )}
          {emr.name && (
            <>
              <span className="subheader">EMR Name:</span>
              <span>{emr.name}</span>
            </>
          )}
          <span className="subheader">Readings:</span>
          <span>{emr.readingsFlag ? 'Yes' : 'No'}</span>

          <span className="text-transform-none">
            {emr.reports && `Report: ${emr.reports}`}
          </span>
        </td>
      </tr>
    </tbody>
  </Table>
);

Dynamic.propTypes = {
  diagnosis: PropTypes.shape().isRequired,
  emr: PropTypes.shape().isRequired,
};

export default Dynamic;
